import Content from "../../components/Content/Content";
import Modify from "../../components/Modify/Modify";
import Nav from "../../components/Nav/Nav";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../components/AuthProvider";
import "./OnaArticle.css";
import axios from "axios";
import { NavLink, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const siteUrl = "https://www.dore-avocat.fr";

function stripHtml(html) {
  return html ? html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim() : "";
}

function OneArticle(props) {
  const params = useParams();
  const [Article, setArticle] = useState([]);

  function getCookie(key) {
    var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
    return b ? b.pop() : "";
  }
  const token = getCookie("_auth");
  useEffect(() => {
    axios
      .get(`https://api.dore-avocat.fr/api/post/${params.id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then(({ data }) => {
        setArticle(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [params.id, token]);
  const { isLoggedIn } = useAuth();
  console.log(isLoggedIn);
  const articleTitle = Article.title
    ? `${Article.title} - Blog Maître Camille Doré`
    : "Article - Blog Maître Camille Doré";
  const articleDescription = Article.content
    ? stripHtml(Article.content).slice(0, 160)
    : "Article du cabinet de Maître Camille Doré, avocate en droit des étrangers à Lille.";
  const articleImage = Article.image
    ? `${siteUrl}/images/${Article.image}`
    : `${siteUrl}/images/logocabinet.png`;

  const articleJsonLd = Article.title
    ? {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline: Article.title,
        description: articleDescription,
        author: {
          "@type": "Person",
          name: Article.author || "Maître Camille Doré",
        },
        publisher: {
          "@type": "LegalService",
          name: "Cabinet Maître Camille Doré",
          logo: { "@type": "ImageObject", url: `${siteUrl}/images/logocabinet.png` },
        },
        image: articleImage,
        datePublished: Article.createdAt,
        url: `${siteUrl}/article/${params.id}`,
        mainEntityOfPage: { "@type": "WebPage", "@id": `${siteUrl}/article/${params.id}` },
      }
    : null;

  return (
    <div>
      <Helmet>
        <title>{articleTitle}</title>
        <meta name="description" content={articleDescription} />
        <link rel="canonical" href={`${siteUrl}/article/${params.id}`} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={articleTitle} />
        <meta property="og:description" content={articleDescription} />
        <meta property="og:url" content={`${siteUrl}/article/${params.id}`} />
        <meta property="og:image" content={articleImage} />
        {articleJsonLd && (
          <script type="application/ld+json">{JSON.stringify(articleJsonLd)}</script>
        )}
      </Helmet>
      <Nav />
      <div className="modify-content">
        {isLoggedIn && Article.length !== 0 && <Modify />}
        <Content />
      </div>
      {Article.length === 0 && (
        <div className="error">
          <div className="error-section">
            <img
              className="logo-connection"
              src="/images/logocabinet.png"
              alt="logo"
            />
            <h1 className="errorTitle">Cet article n'existe pas</h1>
            <p className="message">
              Oups! La page que vous demandez n'existe pas.
            </p>
            <NavLink to="/">
              <button className="back"> Retourner sur la page d'accueil</button>
            </NavLink>
          </div>
        </div>
      )}
    </div>
  );
}

export default OneArticle;
